function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import React from "react";
import { DeleteOutlined } from "@ant-design/icons";
import { Button } from "antd";
import ActionBar from "./ActionBar";
var DeleteBar = function(param) {
    var _param_open = param.open, open = _param_open === void 0 ? false : _param_open, _param_style = param.style, style = _param_style === void 0 ? {} : _param_style, buttonText = param.buttonText, onClick = param.onClick;
    return /*#__PURE__*/ React.createElement(ActionBar, {
        open: open,
        style: _objectSpread({
            position: "fixed"
        }, style)
    }, /*#__PURE__*/ React.createElement(Button, {
        type: "primary",
        danger: true,
        icon: /*#__PURE__*/ React.createElement(DeleteOutlined, null),
        onClick: onClick
    }, buttonText));
};
export default DeleteBar;
